import { defineStore } from "pinia";
import { GalaxyApi } from "@/api";
import {} from "@/api/datasets";
import { useKeyedCache } from "@/composables/keyedCache";
import { rethrowSimple } from "@/utils/simple-error";
export const useDatasetExtraFilesStore = defineStore("datasetExtraFilesStore", () => {
    async function fetchDatasetExtraFiles(params) {
        const { data, error } = await GalaxyApi().GET("/api/datasets/{dataset_id}/extra_files", {
            params: { path: { dataset_id: params.id } },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    }
    const { storedItems, getItemById, isLoadingItem, fetchItemById } = useKeyedCache(fetchDatasetExtraFiles);
    return {
        storedDatasetExtraFiles: storedItems,
        getDatasetExtraFiles: getItemById,
        isLoadingDatasetExtraFiles: isLoadingItem,
        fetchDatasetExtFilesByDatasetId: fetchItemById,
    };
});
